module.exports = __webpack_public_path__ + "static/img/Sydney0360-Edit.956df92.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/company-performance/Sydney0360-Edit.jpg
// module id = dLtv
// module chunks = 0